export default __webpack_public_path__ + "static/media/about6.45ff00ac.png";